export default __webpack_public_path__ + "src/images/packages/summerfields-rose-retreat/cbce47058feeb523ee992ebd561c1cb8-3.jpg";